'use client'

import { FC } from 'react'

const VideoInfoPanelStyles: FC = () => {
  return (
    <style>{`
      .info-panel {
        display: flex;
        flex-direction: column;
        background: white;
        height: 100%;
        position: relative;
      }

      .info-close-button {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        border: none;
        cursor: pointer;
        color: #666;
        border-radius: 50%;
        transition: all 200ms ease;
        z-index: 1;
      }

      .info-close-button:hover {
        background: rgba(0, 0, 0, 0.1);
        color: #333;
      }

      .info-content {
        flex: 1;
        overflow-y: auto;
        padding: 36px;
        /* 下端スタック1段（CVのみ／アンケートのみ）ぶんの逃げ */
        padding-bottom: 100px;
        letter-spacing: 0.02em;
        text-align: justify;
      }

      /* アンケート節（#244）: 展開中の設問シートは境界付きの高さで収める。
         任意設問のオプトインバーは下端スタック（.info-bottom-stack）が担う。 */
      .info-survey-section {
        margin-top: 24px;
        margin-bottom: 22px;
      }

      /* 下端スタックが2段（アンケート＋CV）のときの逃げ。
         bottom19 + padding16*2 + CV49 + gap12 + バー48 = 約160px */
      .info-content--stack-2 {
        padding-bottom: 160px;
      }

      .info-survey-sheet {
        height: min(60vh, 440px);
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
      }

      /*
       * アンケート単独表示（#244）: 設問シート展開中は動画情報/CTA を隠し、
       * アンケートに集中できるようシートをパネル全体へ広げる。
       */
      .info-content--survey-only {
        display: flex;
        flex-direction: column;
        padding-bottom: 36px;
      }

      .info-content--survey-only .info-survey-section {
        flex: 1;
        min-height: 0;
        margin-top: 0;
        margin-bottom: 0;
      }

      .info-content--survey-only .info-survey-sheet {
        height: 100%;
      }

      .info-title {
        font-size: 22px;
        font-weight: bold;
        color: var(--video-brand-color, var(--video-accent-color, #1d48af));
        line-height: 1.7;
        margin-bottom: 18px;
      }

      .info-section {
        margin-bottom: 20px;
      }

      .info-text-section {
        border-top: 1px solid rgba(0, 0, 0, 0.08);
        padding-top: 20px;
      }

      .info-section-label {
        font-size: 12px;
        font-weight: bold;
        color:#808080;
        margin-bottom: 6px;
        /*
         * 親ページ（STUDIO 等）が html / body に line-height を設定していると
         * Shadow DOM を越えて継承され、行高がサイト毎に変わる事象がある。
         * 既定の 1.5 を明示してホストサイト依存を排除する。
         */
        line-height: 1.5;
      }

      .info-section-value {
      font-size: 18px;
        font-weight:bold;
        /* 同上: ホストサイトの line-height 継承を遮断 */
        line-height: 1.5;
        /*
         * 同上: color も継承プロパティのため、ホストサイトが白文字
         * （例: hero セクションに color: #fff）を設定していると
         * Shadow DOM を越えて継承され、白背景のパネル上で見えなくなる。
         */
        color: #1a1a1a;
      }

      .performer-members-group {
        background: #f7f8fa;
        border: 1px solid rgba(0, 0, 0, .07);
        border-radius: 12px;
        overflow: hidden;
      }

      .performer-members {
        display: flex;
        flex-direction: column;
        gap: 0;
        padding: 16px;
      }

      .performer-members + .performer-members {
        padding-top: 0;
      }

      .performer-header {
        display: flex;
        align-items: center;
        gap: 14px;
      }

      .performer-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: linear-gradient(135deg, color-mix(in srgb, var(--video-brand-color, var(--video-accent-color)) 8%, transparent) 0%, color-mix(in srgb, var(--video-brand-color, var(--video-accent-color)) 18%, transparent) 100%);
        border: 1.5px solid color-mix(in srgb, var(--video-brand-color, var(--video-accent-color)) 24%, transparent);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        color: var(--video-brand-color, var(--video-accent-color));
      }

      .performer-info {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
      }

      .performer-department {
        font-size: 13px;
        color: #333333;
        margin-top: 2px;
      }

      .performer-profile {
        width: 100%;
      }

      .performer-profile .markdown-view {
        margin-top: 10px;
        color: #5a5a5a;
        font-size: 13.5px;
        background: #ffffff;
        padding: 14px;
        border-radius: 12px;
      }

      .info-heading {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 12px;
        padding-left: 12px;
        border-left: 3px solid var(--video-brand-color, var(--video-accent-color));
      }

      /* 動画テキストの本文サイズ。PC=15px / SP=16px は動画個別ページ（VideoTextBlock）や
         SP動画モーダル（.sp-detail-section）と揃えた値。BOX は狭い画面で1カラムになり
         このパネルをそのまま縦に積むため、その幅でも他のSP面と同じ 16px にする。 */
      .info-text-section .markdown-view {
        font-size: 16px;
      }

      @media (min-width: 768px) {
        .info-text-section .markdown-view {
          font-size: 15px;
        }
      }

      .info-text {
        font-size: 15px;
        line-height: 1.8;
        color: #444;
      }

      /*
       * 管理画面プレビューでは Shadow DOM を介さず同じモーダルを描画するため、
       * html.dark の MarkdownView 用文字色が白背景へ流れ込む。
       * 情報パネルは常にライト背景なので、パネル配下の色を明示して本番表示と揃える。
       */
      .dark .info-panel .markdown-view {
        color: #444;
      }

      .dark .info-panel .markdown-view h1,
      .dark .info-panel .markdown-view h2,
      .dark .info-panel .markdown-view h3,
      .dark .info-panel .markdown-view h4,
      .dark .info-panel .markdown-view h5,
      .dark .info-panel .markdown-view h6,
      .dark .info-panel .markdown-view strong {
        color: #333;
      }

      .dark .info-panel .performer-profile .markdown-view {
        color: #5a5a5a;
      }

      .info-bottom-fade {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 120px;
        background: linear-gradient(transparent, rgba(255, 255, 255, 0.8), white);
        pointer-events: none;
        z-index: 1;
      }

      /* 下端の追従スタック。アンケートバー → CVボタンの順に積む（SP・動画個別ページと同じ並び） */
      .info-bottom-stack {
        position: absolute;
        bottom: 19px;
        left: 0;
        right: 0;
        padding: 16px 40px;
        z-index: 2;
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      /* CVボタン（.info-cta-button）の見た目は InfoCTAButton 自身が持つ。
         BOX など別レイアウトから呼んでも同じ見た目になるよう共通基盤側へ寄せた。 */
    `}</style>
  )
}

export default VideoInfoPanelStyles
